// Opens the help centre from anywhere: openHelp() for the contents, or
// openHelp("article-id#section-id") straight to a section.
const OPEN_EVENT = "khronos:open-help";
const OPENED_KEY = "khronos_help_opened";

export const openHelp = (topic = null) =>
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { topic } }));

export const onOpenHelp = (handler) => {
  const listener = (e) => handler(e.detail?.topic || null);
  window.addEventListener(OPEN_EVENT, listener);
  return () => window.removeEventListener(OPEN_EVENT, listener);
};

/** Whether the help centre has ever been opened (the Session tab checklist). */
export const hasOpenedHelp = () => {
  try {
    return localStorage.getItem(OPENED_KEY) === "1";
  } catch {
    return false;
  }
};

export const markHelpOpened = () => {
  try {
    localStorage.setItem(OPENED_KEY, "1");
  } catch {
    /* storage disabled: the checklist item simply stays unticked */
  }
};
